define("calendar/components/calendar/social-profiles/remaining-posts", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/service", "@ember/string", "later/utils/compare-strings"], function (_exports, _component, _templateFactory, _component2, _service, _string, _compareStrings) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/service",0,"@ember/string",0,"later/utils/compare-strings",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.displayPostsLeftDropdown}}
    <Shared::Ui::EmberDrop
      @target=".e--postLeft--toggle"
      @position="bottom right"
      @constrainToWindow={{true}}
      @constrainToScrollParent={{true}}
      @contentSelector=".e--postLeft--drop"
      @openOn="hover"
      data-test-id="calendar-social-profiles-remaining-posts-dropdown"
    >
      <div class="o--dropWrapper e--postLeft--drop">
        <div class="o--dropBody--scroll">
          <ul class="o--dropBody__list">
            
            {{#each this.limitedPostProfiles as |profile|}}
              <li class="o--dropBody__item">
                <span class="u--p__tb u--p__lr__xs u--ellipsis">
                  <span class="u--text--light">
                    {{profile.profileType}}
                    {{t "header.navigation.posts_left" count=profile.postsLeft}}
                  </span>
                  <span class="u--float--right {{if profile.boldPostsLeft "u--text--bold"}}">
                    {{profile.postsLeft}}
                  </span>
                </span>
              </li>
            {{/each}}
  
            {{#if this.showGetMorePosts}}
              <li class="o--dropBody__item u--text--right">
                <Shared::Button::Upgrade @feature={{this.upgradeFeature}} @location="multi get more posts" as |upgradeAction|>
                  <Shared::Ui::Button class="u--p__tb u--p__lr__xs u--ellipsis u--cursor" @type="unstyled" onClick={{upgradeAction}}>
                    <span class="u--float--left u--text--success">{{t "header.navigation.get_more_posts"}}</span>
                    <span class="u--float--right">
                      {{svg-jar "nav-right" class="o--icon--xs o--icon--success"}}
                    </span>
                  </Shared::Ui::Button>
                </Shared::Button::Upgrade>
              </li>
            {{else if @canUpgrade}}
              <li class="o--dropBody__item u--text--right">
                <a
                  class="o--dropBody__link open-referral"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="/referrals"
                >
                  <span class="u--float--left">
                    {{t "header.navigation.earn_free_posts"}}
                  </span>
                  {{svg-jar "nav-right" class="o--icon--xs"}}
                </a>
              </li>
            {{/if}}
          </ul>
        </div>
      </div>
    </Shared::Ui::EmberDrop>
    <span class="u--text--sm u--m__r e--postLeft--toggle">
      {{t "header.navigation.view_posts_left"}}
      <span class="u--m__l__xs">
        {{svg-jar "nav-down" class="o--icon--xs"}}
      </span>
    </span>
  
  {{else if this.selectedSocialProfile.hasLimitedPosts}}
    <div class="cCA--header--count">
      <span 
        class="u--text--sm u--text--capitalize"
        data-test-id="calendar-social-profiles-remaining-posts"
      >
        <span class={{if this.boldPostsLeft "u--text--bold"}}> {{this.selectedSocialProfile.postsLeft}} </span>
        {{this.selectedSocialProfile.profileType}}
        {{t "header.navigation.posts_left" count=this.selectedSocialProfile.postsLeft}}
      </span>
      {{#if this.showGetMorePosts}}
        <Shared::Button::Upgrade @feature={{this.upgradeFeature}} @location="get more posts" as |upgradeAction|>
          <Shared::Ui::Button class="u--text--sm u--cursor u--text--success" @type="unstyled" onClick={{upgradeAction}}>
            <span>{{t "header.navigation.get_more_posts"}}</span>
          </Shared::Ui::Button>
        </Shared::Button::Upgrade>
      {{/if}}
    </div>
  {{/if}}
  
  */
  {
    "id": "52kOmo2R",
    "block": "[[[41,[30,0,[\"displayPostsLeftDropdown\"]],[[[1,\"  \"],[8,[39,1],[[24,\"data-test-id\",\"calendar-social-profiles-remaining-posts-dropdown\"]],[[\"@target\",\"@position\",\"@constrainToWindow\",\"@constrainToScrollParent\",\"@contentSelector\",\"@openOn\"],[\".e--postLeft--toggle\",\"bottom right\",true,true,\".e--postLeft--drop\",\"hover\"]],[[\"default\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"o--dropWrapper e--postLeft--drop\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--dropBody--scroll\"],[12],[1,\"\\n        \"],[10,\"ul\"],[14,0,\"o--dropBody__list\"],[12],[1,\"\\n          \\n\"],[42,[28,[37,3],[[28,[37,3],[[30,0,[\"limitedPostProfiles\"]]],null]],null],null,[[[1,\"            \"],[10,\"li\"],[14,0,\"o--dropBody__item\"],[12],[1,\"\\n              \"],[10,1],[14,0,\"u--p__tb u--p__lr__xs u--ellipsis\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"u--text--light\"],[12],[1,\"\\n                  \"],[1,[30,1,[\"profileType\"]]],[1,\"\\n                  \"],[1,[28,[35,4],[\"header.navigation.posts_left\"],[[\"count\"],[[30,1,[\"postsLeft\"]]]]]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,1],[15,0,[29,[\"u--float--right \",[52,[30,1,[\"boldPostsLeft\"]],\"u--text--bold\"]]]],[12],[1,\"\\n                  \"],[1,[30,1,[\"postsLeft\"]]],[1,\"\\n                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n\"]],[1]],null],[1,\"\\n\"],[41,[30,0,[\"showGetMorePosts\"]],[[[1,\"            \"],[10,\"li\"],[14,0,\"o--dropBody__item u--text--right\"],[12],[1,\"\\n              \"],[8,[39,5],null,[[\"@feature\",\"@location\"],[[30,0,[\"upgradeFeature\"]],\"multi get more posts\"]],[[\"default\"],[[[[1,\"\\n                \"],[8,[39,6],[[24,0,\"u--p__tb u--p__lr__xs u--ellipsis u--cursor\"],[16,\"onClick\",[30,2]]],[[\"@type\"],[\"unstyled\"]],[[\"default\"],[[[[1,\"\\n                  \"],[10,1],[14,0,\"u--float--left u--text--success\"],[12],[1,[28,[35,4],[\"header.navigation.get_more_posts\"],null]],[13],[1,\"\\n                  \"],[10,1],[14,0,\"u--float--right\"],[12],[1,\"\\n                    \"],[1,[28,[35,7],[\"nav-right\"],[[\"class\"],[\"o--icon--xs o--icon--success\"]]]],[1,\"\\n                  \"],[13],[1,\"\\n                \"]],[]]]]],[1,\"\\n              \"]],[2]]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[41,[30,3],[[[1,\"            \"],[10,\"li\"],[14,0,\"o--dropBody__item u--text--right\"],[12],[1,\"\\n              \"],[10,3],[14,0,\"o--dropBody__link open-referral\"],[14,\"target\",\"_blank\"],[14,\"rel\",\"noopener noreferrer\"],[14,6,\"/referrals\"],[12],[1,\"\\n                \"],[10,1],[14,0,\"u--float--left\"],[12],[1,\"\\n                  \"],[1,[28,[35,4],[\"header.navigation.earn_free_posts\"],null]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[1,[28,[35,7],[\"nav-right\"],[[\"class\"],[\"o--icon--xs\"]]]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]],null]],[]]],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n  \"],[10,1],[14,0,\"u--text--sm u--m__r e--postLeft--toggle\"],[12],[1,\"\\n    \"],[1,[28,[35,4],[\"header.navigation.view_posts_left\"],null]],[1,\"\\n    \"],[10,1],[14,0,\"u--m__l__xs\"],[12],[1,\"\\n      \"],[1,[28,[35,7],[\"nav-down\"],[[\"class\"],[\"o--icon--xs\"]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"]],[]],[[[41,[30,0,[\"selectedSocialProfile\",\"hasLimitedPosts\"]],[[[1,\"  \"],[10,0],[14,0,\"cCA--header--count\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"u--text--sm u--text--capitalize\"],[14,\"data-test-id\",\"calendar-social-profiles-remaining-posts\"],[12],[1,\"\\n      \"],[10,1],[15,0,[52,[30,0,[\"boldPostsLeft\"]],\"u--text--bold\"]],[12],[1,\" \"],[1,[30,0,[\"selectedSocialProfile\",\"postsLeft\"]]],[1,\" \"],[13],[1,\"\\n      \"],[1,[30,0,[\"selectedSocialProfile\",\"profileType\"]]],[1,\"\\n      \"],[1,[28,[35,4],[\"header.navigation.posts_left\"],[[\"count\"],[[30,0,[\"selectedSocialProfile\",\"postsLeft\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,0,[\"showGetMorePosts\"]],[[[1,\"      \"],[8,[39,5],null,[[\"@feature\",\"@location\"],[[30,0,[\"upgradeFeature\"]],\"get more posts\"]],[[\"default\"],[[[[1,\"\\n        \"],[8,[39,6],[[24,0,\"u--text--sm u--cursor u--text--success\"],[16,\"onClick\",[30,4]]],[[\"@type\"],[\"unstyled\"]],[[\"default\"],[[[[1,\"\\n          \"],[10,1],[12],[1,[28,[35,4],[\"header.navigation.get_more_posts\"],null]],[13],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[4]]]]],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[]]]],[\"profile\",\"upgradeAction\",\"@canUpgrade\",\"upgradeAction\"],false,[\"if\",\"shared/ui/ember-drop\",\"each\",\"-track-array\",\"t\",\"shared/button/upgrade\",\"shared/ui/button\",\"svg-jar\"]]",
    "moduleName": "calendar/components/calendar/social-profiles/remaining-posts.hbs",
    "isStrictMode": false
  });

  let RemainingPostsComponent = (_class = class RemainingPostsComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor2, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor3, this);
    }

    get displayPostsLeftDropdown() {
      return Boolean(this.selectedSocialProfiles.hasMultipleSelected && this.limitedPostProfiles.length);
    }

    get isGetMorePostsABTestVariant() {
      var _this$auth$currentAcc, _this$auth$currentAcc2;

      // Note: partial 100% rollout for paid users
      return this.isFree ? (0, _compareStrings.areStringsEqual)((_this$auth$currentAcc = this.auth.currentAccount) === null || _this$auth$currentAcc === void 0 ? void 0 : (_this$auth$currentAcc2 = _this$auth$currentAcc.experiments) === null || _this$auth$currentAcc2 === void 0 ? void 0 : _this$auth$currentAcc2['web_near-post-limit_get-more-posts'], 'get-more') : this.subscriptions.subscriptionPlan.hasLimitedPosts;
    }

    get isFree() {
      var _this$auth$currentAcc3;

      return !((_this$auth$currentAcc3 = this.auth.currentAccount) !== null && _this$auth$currentAcc3 !== void 0 && _this$auth$currentAcc3.hasActiveSubscription);
    }

    get isFreeEligibleForTrial() {
      var _this$auth$currentAcc4;

      return this.isFree && ((_this$auth$currentAcc4 = this.auth.currentAccount) === null || _this$auth$currentAcc4 === void 0 ? void 0 : _this$auth$currentAcc4.canTrialPlan);
    }

    get limitedPostProfiles() {
      return this.selectedSocialProfiles.profiles.filter(profile => profile.hasLimitedPosts).map(profile => ({
        postsLeft: profile.postsLeft,
        profileType: (0, _string.capitalize)(profile.profileType),
        boldPostsLeft: this.isGetMorePostsABTestVariant && profile.postsLeft <= this.args.getMorePostsThreshold
      }));
    }

    get boldPostsLeft() {
      if (!this.isGetMorePostsABTestVariant) {
        return false;
      }

      return this.selectedSocialProfile.postsLeft <= this.args.getMorePostsThreshold;
    }

    get selectedSocialProfile() {
      return this.selectedSocialProfiles.firstProfile;
    }

    get showGetMorePosts() {
      var _this$auth$currentAcc5;

      if (!this.isGetMorePostsABTestVariant) {
        return false;
      }

      if ((_this$auth$currentAcc5 = this.auth.currentAccount) !== null && _this$auth$currentAcc5 !== void 0 && _this$auth$currentAcc5.isOnLegacyPlan) {
        return false;
      }

      if (this.displayPostsLeftDropdown) {
        return this.selectedSocialProfiles.profiles.filter(profile => profile.hasLimitedPosts).some(profile => profile.postsLeft <= this.args.getMorePostsThreshold);
      }

      return this.selectedSocialProfile.postsLeft <= this.args.getMorePostsThreshold;
    }

    get upgradeFeature() {
      return this.isFreeEligibleForTrial ? 'trialPlansSnapshot' : 'plans';
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = RemainingPostsComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, RemainingPostsComponent);
});